import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Featured.css";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardControlKeyIcon from "@mui/icons-material/KeyboardControlKey";

const Featured = () => {
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axios.get("http://127.0.0.1:5000/api/payments");
        setPaymentData(response.data);
      } catch (err) {
        setError("Erreur lors de la récupération des paiements.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  if (loading) return <div>Chargement des paiements...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  // Calculs basés sur les données récupérées
  const totalRevenue = paymentData.reduce((sum, payment) => sum + payment.totalPrice, 0);

  // Filtrer les paiements réussis
  const completedPayments = paymentData.filter((payment) => payment.status === "success");

  // Calcul des revenus totaux des paiements réussis
  const completedRevenue = completedPayments.reduce((sum, payment) => sum + payment.totalPrice, 0);

  // Dates limites pour la semaine dernière et le mois dernier
  const now = new Date();
  const lastWeek = new Date();
  lastWeek.setDate(now.getDate() - 7); // Une semaine en arrière
  const lastMonth = new Date();
  lastMonth.setMonth(now.getMonth() - 1); // Un mois en arrière

  // Calcul des revenus de la semaine dernière
  const lastWeekRevenue = completedPayments
    .filter(payment => new Date(payment.date) >= lastWeek && new Date(payment.date) <= now)
    .reduce((sum, payment) => sum + payment.totalPrice, 0);

  // Calcul des revenus du mois dernier
  const lastMonthRevenue = completedPayments
    .filter(payment => new Date(payment.date) >= lastMonth && new Date(payment.date) < lastWeek)
    .reduce((sum, payment) => sum + payment.totalPrice, 0);

  return (
    <div className="featured">
      <div className="top">
        <h1 className="title">Total Revenue</h1>
        <MoreVertOutlinedIcon fontSize="small" />
      </div>

      <div className="bottom">
      <div className="featuredChart">
  <CircularProgressbar 
    value={totalRevenue > 0 ? (completedRevenue / totalRevenue) * 100 : 0} 
    text={`${
      totalRevenue > 0 
        ? Math.round((completedRevenue / totalRevenue) * 100) 
        : 0
    }%`} 
    strokeWidth={5} 
  />
</div>


        <p className="title">Ventes totales réalisées aujourd'hui</p>
        <p className="amount">{totalRevenue.toLocaleString()} TND</p>
        <p className="desc">
          Traitement des transactions précédentes. Les derniers paiements peuvent ne pas être inclus.
        </p>
        <div className="summary">
       
          <div className="item">
            <div className="itemTitle">Dernières Semaine</div>
            <div className="itemResult positive">
              <KeyboardControlKeyIcon fontSize="small" />
              <div className="resultAmount">{lastWeekRevenue.toLocaleString()} TND</div>
            </div>
          </div>
          <div className="item">
            <div className="itemTitle">Dernier mois</div>
            <div className="itemResult positive">
              <KeyboardControlKeyIcon fontSize="small" />
              <div className="resultAmount">{lastMonthRevenue.toLocaleString()} TND</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;
